import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import images from "../../assets/images";
import RegisterFree from "../../components/RegisterFree";
import { getLocalization } from "../../redux/localization";

const SecondSection = () => {
  const t = useSelector(getLocalization);
  return (
    <section className="adSection2">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col md={6}>
            <img src={images.section2} alt="Rentificial" width={"50%"} />
          </Col>
          <Col md={6}>
            <h2>{t.getString("Why Rental Management Application?")}</h2>
            <p>
              {t.getString(
                "Well, then how can firms providing renting services follow the track of the vehicles/goods that they have rented?"
              )}
              <br /> <br />{" "}
              {t.getString(
                "There are some applications to manage all stages in renting activities without experiencing any problem and to benefit from the incomes"
              )}
              <br /> <br />{" "}
              {t.getString(
                "Let’s mention about the benefit of such applications for you"
              )}
            </p>
            <RegisterFree />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default SecondSection;
